import { ErrorForApiPropertyModel } from '@models/error-handling/error-for-api-property.model';

/**
 * This object is used for reporting front errors to the backend api for reporting and troubleshooting
 *
 * @class ErrorForApiModel
 * @property {string} message - the error message
 * @property {string} stack - stack trace of the error
 * @property {string} type - type of error (not currently used)
 * @property {ErrorForApiPropertyModel} properties - key value pair with the following
 *            {string} referenceNumber - uuid generated by front end
 *            {string} httpErrorCode - http code associated with the error (if provided)
 *            {string} userName - the username of the person using the application
 *            {string} timestamp - ISO timestamp when the error was generated
 *            {string} uri - the uri route where the error was generated from
 * @property {any} metrics - key value pair for sending metrics - numbers only (not currently used)
 */
export class ErrorForApiModel {
  message: string = undefined;
  stack: string = undefined;
  type?: string = undefined;
  properties: ErrorForApiPropertyModel = undefined;
  metrics?: any = undefined;
}
